export var ADD_QUANTITY = 'add';
export var SUBTRACT_QUANTITY = 'subtract';
export var DELETE_ITEM_MODAL_HEADER = 'Remove item?';
export var DELETE_ITEM_MODAL_CONTENT = 'Are you sure you want to remove this?  You will need to go back to the menu if you’d like to add it back.';